import { computed } from "vue";

const IS_TOUCH_SCREEN = "(pointer: coarse)";
const IS_MD_SCREEN = "screen and (min-width: 768px)";
const IS_LG_SCREEN = "screen and (min-width: 1024px)";
const IS_XL_SCREEN = "screen and (min-width: 1280px)"

export function useDevice() {

  const isTouchScreen = computed(() => {
    return window.matchMedia(IS_TOUCH_SCREEN).matches;
  });

  const isMinimumMdScreen = computed(() => {
    return window.matchMedia(IS_MD_SCREEN).matches;
  });

  const isMinimumLgScreen = computed(() => {
    return window.matchMedia(IS_LG_SCREEN).matches;
  })

  const isMinimumXlScreen = computed(() => {
    return window.matchMedia(IS_XL_SCREEN).matches;
  });

  return {
    isTouchScreen,
    isMinimumMdScreen,
    isMinimumLgScreen,
    isMinimumXlScreen,
  };
}
